export default __webpack_public_path__ + "static/media/jump_rope.7b3643e6.gif";